/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import { GlobalLetterDefaultValues } from '../hooks';

type Response = {
  success: boolean;
  message: string;
};

export const saveGlobalLetter = withLogger(
  async (payload: Record<string, any>): Promise<Response> => {
    const url = globalLetterAPIUrls.save;
    const mergedPayload = { ...GlobalLetterDefaultValues };

    const isEmpty = (value: any) => {
      if (value === null || value === undefined) return true;
      if (typeof value === 'string' && value.trim() === '') return true;
      if (typeof value === 'object' && !Array.isArray(value)) {
        return Object.keys(value).length === 0;
      }
      return false;
    };

    const deepMerge = (target: any, source: any) => {
      for (const key in source) {
        if (source.hasOwnProperty(key)) {
          if (
            typeof source[key] === 'object' &&
            source[key] !== null &&
            !Array.isArray(source[key])
          ) {
            if (!target[key]) target[key] = {};
            deepMerge(target[key], source[key]);
          } else if (!isEmpty(source[key])) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };

    const finalPayload = deepMerge(mergedPayload, payload);

    const { data } = await authServiceAxiosClient.post<Response>(
      url,
      finalPayload,
    );

    return data;
  },
);
